var DarkMode = function () {
    var darkSwitch

    // form yüklendiğinde
    var formHandle = function () {
        darkSwitch.addEventListener("change", function (event) {
            resetTheme();
        });
    }

    // başlangıç localstorage kontrolü
    var initTheme = function () {
        var darkThemeSelected =
            localStorage.getItem("darkSwitch") !== null &&
            localStorage.getItem("darkSwitch") === "dark";
        darkSwitch.checked = darkThemeSelected;
        darkThemeSelected
            ? document.body.setAttribute("data-theme", "dark")
            : document.body.removeAttribute("data-theme");
    }

    // resetleme
    var resetTheme = function () {
        if (darkSwitch.checked) {
            document.body.setAttribute("data-theme", "dark");
            localStorage.setItem("darkSwitch", "dark");

        } else {
            document.body.removeAttribute("data-theme");
            localStorage.removeItem("darkSwitch");
        }
    }

    return {
        init: function () {
            darkSwitch = document.getElementById("darkSwitch");
            if (!darkSwitch) {
                return;
            }
            initTheme();
            formHandle();
        }
    }
}();

$(function () {
    DarkMode.init();
});

